import React from "react";
import ContentContainer from "../../components/ContentContainer/ContentContainer";

import s from "../../comon/ComonAdmin.module.scss";
//обнуляющие стили
import "../../comon/_null_style.css";

//компоненты, из которых состоит страница
import ProfilePanel from "../../components/AdminComponents/ProfilePanelComponent/index";
import CreateTournament from "../../components/AdminComponents/CreateTournament/index";

//const
import { pageInfo } from "./const";
import { profileInfo, uploadImg, convertDateISO8601 } from "../../comon/comonConst";

const EditEvent = () => (
  <div className={s.evensPageContainer}>
    <ProfilePanel pageInfo={pageInfo} profileInfo={profileInfo} />
    <ContentContainer MainBlock={null} MainCreateBlock={true}>
      <CreateTournament convertDateISO8601={convertDateISO8601} uploadImg={uploadImg} />
    </ContentContainer>
  </div>
);

export default EditEvent;
